export default __webpack_public_path__ + "static/name-display-e55632801076882702c219b4359397f8.png";